import React from 'react';
import { motion } from 'framer-motion';

const Hero = ({ onOpenModal }) => {

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-16" id="hero">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gradient-to-r from-accent/10 to-primary/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-secondary/5 to-accent/5 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Content */}
          <motion.div 
            className="text-center lg:text-left"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
          >

            {/* Main Heading */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground mb-8 leading-tight font-mono">
              <span className="text-foreground">&gt;</span> Elevate Industrial{' '}
              <span className="text-foreground">
                Intelligence
              </span>{' '}
              <br />
              <span className="text-foreground">with</span> Annotated AI-Simulated{' '}
              <span className="text-foreground">DataSets</span>
            </h1>
            
            {/* Description */}
            <div className="text-lg sm:text-xl text-foreground-secondary mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-mono">
              <div className="mb-2">
                <span className="text-foreground-secondary">//</span> Power your AI/ML development with synthetic datasets
              </div>
              <div className="mb-2">
                <span className="text-foreground-secondary">//</span> tailored to your process and device. Simulate regular
              </div>
              <div className="mb-2">
                <span className="text-foreground-secondary">//</span> experiences, rare behavior, anomalies, and edge cases
              </div>
              <div>
                <span className="text-foreground-secondary">//</span> accelerating innovation and expanding possibilities
              </div>
            </div>
            
            {/* CTA Button */}
            <div className="flex justify-center lg:justify-start mb-12">
              <motion.button 
                onClick={() => onOpenModal && onOpenModal()}
                className="btn btn-primary btn-lg"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Materialize It!
              </motion.button>
            </div>

            {/* Trust Indicators */}
            <motion.div 
              className="text-sm text-foreground-secondary max-w-xl mx-auto lg:mx-0 font-mono mt-8"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <div className="flex items-center justify-center lg:justify-start">
                <span className="text-foreground-secondary">[INFO]</span>
                <span className="mx-4"></span>
                <span>System leverages advanced physics-aware AI models to generate realistic data sequences, simulating diverse scenarios</span>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Column - Image */}
          <motion.div 
            className="flex justify-center lg:justify-end"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1], delay: 0.2 }}
          >
            <div className="hero-image-container">
              <img 
                src="/simulate.png" 
                alt="Simulate Experience" 
                className="hero-simulate-img"
              />
            </div>
          </motion.div>
        </div>
        
      </div>
    </section>
  );
};

export default Hero;
